import EfFootNotes from '@elem/ui/ef-foot-notes';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('delta3series');

    const configs = {
        text: 'Q_text',
        langKey: 'delta3series',
        links: [t('Q_a1'), t('Q_a2')],
        emails: [t('Q_mail1')],
    };
    return (
        <div className={styles.TheComp}>
            <EfFootNotes {...configs} />
        </div>
    );
}
